<template>
    <div class="invitation-article-bg">
        <div class="content" v-html="data.content"></div>
    </div>
</template>

<script>
    import Request from '@request'
    import api from '@api'

    export default {
        components: {},
        props: {},
        data() {
            return {
                data: {},
            }
        },
        computed: {

        },
        created() {
            this.getData()
        },
        mounted() {

        },
        methods: {
            getData() {
                Request.post(api.invitation.buttonContent, {
                    id: this.$route.query.id
                }).then(res => {
                    const {
                        data
                    } = res
                    this.data = data
                    document.title = '详情'
                })
            },

        },
    }
</script>
<style>

</style>
<style scoped>
    .invitation-article-bg {
        width: 100%;
        height: 100%;
        background: white;
    }

    .content {
        height: 100%;
        overflow-y: auto;
    }
</style>